import React from "react";
import Heading from "../Products/Heading";
import Product from "../Products/Product";
import {
  KajuPenuts,
  RoastedPenuts,
  TikhaPeanuts,
} from "../../../assets/images/index";

const Processfood = () => {
  return (
    <section className="w-full pb-20">
      <Heading heading="Processed Food – Premium Export Quality" />

      <div className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-3 xl:grid-cols-4 gap-10">

        {/* ===========================
            ROASTED PEANUTS – SEO OPTIMIZED
        =========================== */}
        <Product
          _id="PF1102"
          img={RoastedPenuts}
          productName="Roasted Peanuts – Super Bold 35/40"
          price=""
          color="Rich Golden Brown"
          badge={false}
          Taste="Crispy & naturally nutty flavor"
          Varities="Super Bold – 35/40 Grade"
          size="Export Grade"
          des="Premium Indian Roasted Peanuts, carefully selected Super Bold 35/40 grade. Expertly roasted to achieve a perfect crunch and enhanced natural aroma. Ideal for international buyers seeking high-quality snack products. Suitable for retail packing, bulk supply, and private labeling. 100% natural, high in protein, and perfect for healthy snacking."
        />

        {/* ===========================
            TIKHA PEANUTS – SEO OPTIMIZED
        =========================== */}
        <Product
          _id="PF1103"
          img={TikhaPeanuts}
          productName="Spicy Tikha Peanuts – Super Bold 35/40"
          price=""
          color="Reddish-Brown"
          badge={false}
          Taste="Hot, tangy, and crunchy"
          Varities="Super Bold – 35/40 Grade"
          size="Export Quality"
          des="Authentic Indian Tikha (Spicy) Peanuts made using premium Super Bold peanuts. Coated with a traditional spicy blend including chili, cumin, and aromatic masalas. Perfect for global markets offering Indian snack varieties. A bold, flavorful, and crunchy snack ideal for wholesale, export, and private label packaging."
        />

        {/* ===========================
            KAJU PEANUTS – SEO OPTIMIZED
        =========================== */}
        <Product
          _id="PF1101"
          img={KajuPenuts}
          productName="Kaju Peanuts – Premium Fusion Mix"
          price=""
          color="Beige Cashews & Golden Peanuts"
          badge={false}
          packaging="Bulk & Retail Packs Available"
          size="Super Bold – 35/40"
          Varities="Fusion Peanut-Cashew Mix"
          des="A premium fusion of crunchy peanuts and rich cashews, crafted for export buyers seeking unique Indian snack blends. Perfectly roasted for a delightful combination of creamy and crunchy textures. Suitable for supermarkets, distributors, and international snack brands. High in nutrients and ideal for bulk international shipments."
        />

      </div>
    </section>
  );
};

export default Processfood;
